<template>
  <div class="recommended-threads-section">
    <loading-spinner v-if="loading !== 0" />
    <div
      v-for="recoThread in recommend"
      v-else-if="recommend && recommend.length > 0"
      :key="`thread-${recoThread.id}`"
      class="recommended-threads-section__recommendation"
    >
      <recommended-thread-teaser :thread="recoThread" />
    </div>
  </div>
</template>

<script>
import RecommendedThreadTeaser from '@/components/Forum/RecommendedThreadTeaser.vue';
import { GET_RECOMMENDATIONS } from '@/graphql/queries/recommendation-queries';

export default {
  name: 'RecommendedThreadsSection',
  components: {
    RecommendedThreadTeaser,
  },
  props: {
    threadId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      recommend: [],
      loading: 0,
    };
  },
  apollo: {
    recommend: {
      query: GET_RECOMMENDATIONS,
      variables() {
        return {
          assocId: this.threadId,
          assocType: 'THREAD',
          docResultType: 'THREAD',
        };
      },
      result({ data }) {
        if (data && data.recommend) {
          this.$store.dispatch('updateGlobalContext', {
            recommendedContent: {
              location: 'Thread',
              ids: data.recommend.map((rec) => rec.id),
            },
          });
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_recommended-threads-section';
</style>
